import { PlanGridModel } from 'api/models';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';
import axios from 'axios';

export const activatePlanGrid = async () => {
    const { data } = await http.post(`${getApiUrl()}/plugins/plan-grid`);

    return PlanGridModel.fromObject(data);
};

export const deactivatePlanGrid = async () => {
    await http.delete(`${getApiUrl()}/plugins/plan-grid`);
};

export const unauthorizePlanGrid = async () => {
    await http.delete(`${getApiUrl()}/plangrid/auth/unauthorize`);
};

export const getAuthenticationPlanGridStatus = async () => {
    const { data } = await http.get(`${getApiUrl()}/plangrid/auth/status`);

    return data;
};

export const getPlanGrid = async () => {
    const { data } = await http.get(`${getApiUrl()}/plugins/plan-grid`);

    return PlanGridModel.fromObject(data);
};

export const authenticatePlanGrid = async (token: string, payload: { code: string; redirectUri: string }) => {
    const { data } = await axios.post(
        `${getApiUrl()}/plangrid/auth/callback`,
        {
            code: payload.code,
            redirectUri: payload.redirectUri,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return data;
};

export const loginPlanGrid = async () => {
    const { data } = await http.get(`${getApiUrl()}/plangrid/auth/login`);
    return data as { authUrl: string };
};
